import axios from 'axios';

export default {
	getSlayer() {
		return axios.get('/static/portal/sw/json/sales-layer.json');
	}
};
